import { useEffect } from "react";

import type { AccountDTO } from "../../common/types/AccountDTO";
import type { UserDTO } from "../../common/types/UserDTO";
import type { VenueDTO } from "../../common/types/VenueDTO";
import { useGetConfigQuery } from "../store/services/config";
import { intercomHandler } from "../utils/intercom";
import { useDispatch } from "react-redux";
import { updateUnreadCount } from "../store/services/intercom";

export const useIntercom = (user?: UserDTO, venue?: VenueDTO, account?: AccountDTO) => {
  const { data: config } = useGetConfigQuery();
  const appId = config?.intercomAppId;
  const dispatch = useDispatch();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (user && account && appId && window.Intercom) {
      const fullName = `${user.properties?.firstName} ${user.properties?.lastName}`;
      // TODO: Replace with a dedicated IS_PAID feature once it exists
      const accountType = "Premium";

      window.Intercom("boot", {
        app_id: appId,
        email: user.email,
        user_id: user.id.toString(),
        name: fullName,
        dexibit_account_id: account.id,
        dexibit_account_name: account.name,
        dexibit_venue_id: venue?.id,
        dexibit_venue_name: venue?.name,
        dexibit_user_id: user.id,
        dexibit_user_full_name: fullName,
        dexibit_user_first_name: user.properties?.firstName,
        dexibit_email: user.email,
        dexibit_role: user.roles[0],
        dexibit_account_type: accountType,
        dexibit_access_enabled: user.enabled,
        // Can add company info here using account data
        // Must wait for new Intercom instance
      });

      intercomHandler.updateIntercomInterval();
      intercomHandler.onUnreadCountChange((unreadCount) =>
        dispatch(updateUnreadCount({ unreadCount })),
      );
    }
  }, [user, venue, account, appId]);
};
